import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { FadeUp, Overline } from "@/components/Reveal";
import { Process } from "@/sections/Process";
import { Confidence } from "@/sections/Confidence";

const MODES = [
  {
    title: "Stock",
    text: "Products that are actually available and can be allocated against a confirmed requirement.",
    dot: "#10B981",
  },
  {
    title: "Allocation",
    text: "Products our supply partners can allocate, confirmed against quantity, destination and timeline.",
    dot: "#F59E0B",
  },
  {
    title: "Sourcing",
    text: "Products sourced internationally against a confirmed client requirement and commercial framework.",
    dot: "#0A192F",
  },
];

export default function Supply() {
  return (
    <div className="bg-white min-h-screen" data-testid="supply-page">
      <Seo
        title="Supply & Sourcing — Royal Deals FZ-LLC"
        description="Stock, allocation and sourcing: how Royal Deals FZ-LLC secures enterprise compute hardware across international supply channels for qualified buyers."
      />
      <Nav />
      <main className="pt-44">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24">
          <FadeUp>
            <Overline>Supply &amp; Sourcing</Overline>
            <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tight text-midnight max-w-4xl leading-[1.05]">
              Three ways we secure compute.
            </h1>
            <p className="text-midnight/60 text-lg mt-8 max-w-2xl leading-relaxed">
              Every engagement is qualified against one of three supply modes — so buyers know exactly what kind of availability they are looking at.
            </p>
          </FadeUp>

          <div className="grid md:grid-cols-3 gap-5 mt-16">
            {MODES.map((m, i) => (
              <FadeUp key={m.title} delay={i * 0.1}>
                <div className="bg-white hairline shadow-soft p-10 h-full hover:shadow-medium transition-shadow duration-300" data-testid={`supply-mode-${m.title.toLowerCase()}`}>
                  <span className="inline-block w-2.5 h-2.5 rounded-full mb-6" style={{ backgroundColor: m.dot }} />
                  <p className="font-heading text-xl font-medium text-midnight mb-4">{m.title}</p>
                  <p className="text-midnight/55 text-sm leading-relaxed">{m.text}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>

        <Process />
        <Confidence />
      </main>
      <Footer />
    </div>
  );
}
